export const zIndex = {
  stickyHeader: 100,
  dropdown: 1000,
  tooltip: 1000,
  modal: 3500,
  tooltipInModal: 4000,
  toastNotification: 1000000,
  minimumModal: 2,
}
